import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ToolsAndMaterialsCondition } from '../../../shared/interfaces';
import { AppSettings } from '../../../shared/models';
import { AbstractBasicDataApiService } from '../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class ToolsAndMaterialsConditionApiService extends AbstractBasicDataApiService<ToolsAndMaterialsCondition> {

  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.basicinformation.toolsAndMaterials.condition);
  }
}
